/** Icons generated by create-react-icons. Don't edit this file directly. **/
import React from "react";
import PropTypes from "prop-types";

export function Code(props) {
  const { size, color, ...other } = props;
  return (
    <svg viewBox="0 0 22 18" fill="none" height={size} width={size} {...other}>
      <path
        d="M6 17C4.61929 17 3.5 15.8807 3.5 14.5V11.5C3.5 10.1193 2.38071 9 1 9C2.38071 9 3.5 7.88071 3.5 6.5V3.5C3.5 2.11929 4.61929 1 6 1M16 1C17.3807 1 18.5 2.11929 18.5 3.5V6.5C18.5 7.88071 19.6193 9 21 9C19.6193 9 18.5 10.1193 18.5 11.5V14.5C18.5 15.8807 17.3807 17 16 17M7.675 9.082C7.675 9.05439 7.65261 9.032 7.625 9.032C7.59739 9.032 7.575 9.05439 7.575 9.082C7.575 9.10961 7.59739 9.132 7.625 9.132C7.65261 9.132 7.675 9.10961 7.675 9.082ZM11.05 9.073C11.05 9.04539 11.0276 9.023 11 9.023C10.9724 9.023 10.95 9.04539 10.95 9.073C10.95 9.10061 10.9724 9.123 11 9.123C11.0276 9.123 11.05 9.10061 11.05 9.073ZM14.05 9.073C14.05 9.04539 14.0276 9.023 14 9.023C13.9724 9.023 13.95 9.04539 13.95 9.073C13.95 9.10061 13.9724 9.123 14 9.123C14.0276 9.123 14.05 9.10061 14.05 9.073Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

Code.defaultProps = {
  color: "currentColor",
  size: 24,
};

Code.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
